import {Modal} from '../index';
import {useDispatch} from 'react-redux';
import {closeModal, updateModal} from '../../../../reducers/modules/actions';

export default ({modal, data}) => {
    const dispatch = useDispatch();

    return (
        <>
            <div className="creative-header" style={{
                background: `url(${window.location.origin}/source/modules/modals/facebook-post/background.png)`,
                backgroundSize: 'cover'
            }}>
                <div className="close" onClick={e => dispatch(closeModal())}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18 18L6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> 
                </div>

                <div className="creative-shadow"></div>
            </div>

            <div className="modal-text" style={{marginTop: '-30px'}}>
                <div className="title">Facebook Bonus</div>
                <div className="description" style={{textAlign: "center", width: "80%"}}>Share Lucksy with your friends and get rewarded!</div>
            </div>

            <div className="modal-stages">
                <div className="stage">
                    <div className="stage-value">1</div>
                    <div className="stage-text">Share the post with your invite link</div>
                </div>

                <div className="stage">
                    <div className="stage-value">2</div>
                    <div className="stage-text">Send us a link to your <b>public</b> profile</div>
                </div>

                <div className="stage">
                    <div className="stage-value">3</div>
                    <div className="stage-text">Get your bonus</div>
                </div>
            </div>

            <div className="block">
                <div className="modal-button blue" onClick={e => {
                    dispatch(updateModal('facebook_post', {
                        stage: "share"
                    }))
                }}>
                    Start task
                </div>
            </div>
        </>
    )
} 